import Capitan from '../../code/js/Capitan/Capitan';
import CapSmartResize from '../../code/js/Capitan/es6/CapSmartResize';
var _ = {
  defaults: {
    componentSelector: '.stage--full',
    selectors: {
      breadcrumb: '.breadcrumb'
    }
  }
};
var o = _.defaults;

var onResize = function onResize() {
  addPadding();
};

var addPadding = function addPadding() {
  var stage = document.querySelector(o.componentSelector);
  var breadcrumb = document.querySelector(o.selectors.breadcrumb);

  if (breadcrumb.offsetHeight && stage && Capitan.assertBreakpoint('lt', 'xl')) {
    stage.style.paddingTop = "".concat(breadcrumb.offsetHeight - 15, "px");
  } else if (stage) {
    stage.style.paddingTop = "30px";
  } else {
    return;
  }
};
/**
 * initialize the component
 * @export function
 */


export function init() {
  if (document.querySelector(o.componentSelector || '.stage--glow') && document.querySelector(o.selectors.breadcrumb) && document.body.classList.contains('has-stage')) {
    addPadding();
  }

  CapSmartResize(function () {
    return onResize();
  }, 100, false, this);
}